module.exports = __webpack_public_path__ + "img/penedile-sa.11cad6b8.jpg";